import React, { useState, useEffect } from 'react'
import { Redirect } from 'react-router-dom';
import { Container, Row, Col, Image, Carousel, Accordion, Card, Spinner } from 'react-bootstrap';
import Footer from '../Footer/Footer';
import './LandingPage.scss';
import PandaButton from '../utilities/PandaButton';
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';
import { DATE_UN_SHOT, NOSOTROS, PANDA_MIX, PANDA_TRONIC, PANDA_YELLOW, PANDA_PURPLE, EXPERIENCIA, CLIENTES, PRODUCTOS, EVENTOS } from '../../images/images'
import { api } from '../utilities/fetch';
import parse from 'html-react-parser';

export default function LandingPage() {

    const prevIcon = <span aria-hidden="true" className="custom-prev-icon" />	
    const nextIcon = <span aria-hidden="true" className="custom-next-icon" />

    const [nosotros, setNosotros] = useState(null);
    const [stats, setStats] = useState({});
    const [products, setProducts] = useState(null);
    const [loading, setLoading] = useState(true);
    const [events, setEvents] = useState(null);
    const [clients, setClients] = useState(null);
    const [faq, setFaq] = useState([]);

    useEffect(() => {
        const getData = async () => {
            const faqList = await api.get('faq');
            const statList = await api.get('stats');
            const postNosotros = await api.get('posts?title=nosotros');
            setNosotros(postNosotros.data[0]);
            setFaq(faqList.data);
            const newStats = {};
            statList.data.forEach(entry => {
                newStats[entry.slug] = Number(entry.meta.ammount);
            });
            setStats(newStats);
            setLoading(false);
        }
        getData()
    }, [])

    const isOfAge = sessionStorage.getItem('ofAge');

    const countUpOnViewport = (isVisible) => {
        if (isVisible && products && events && clients) {
            products.restart();
            events.restart();
            clients.restart();
        }
    }

    if (!isOfAge) {
        return (
            <Redirect to={{pathname: "/warning"}} />
        )
    }

    const renderFAQ = () => {
        faq.sort((a, b) => (a.id - b.id));
        return faq.map(entry => (
            <Card className="faq-card" key={entry.id}>
                <Accordion.Toggle as={Card.Header} eventKey={entry.id}>
                    {entry.title.rendered}
                </Accordion.Toggle>
                <Accordion.Collapse eventKey={entry.id}>
                    <Card.Body>
                        {parse(entry.excerpt.rendered)}
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
        ));
    }

    if (loading) {
        return (
            <div className="landing-loader">
                <Spinner animation='border' />
            </div>
        );
    }

    return (
        <div className="landing-page">
            <section id="top">
                <Image src={DATE_UN_SHOT} fluid/>
            </section>
            <section id="nosotros">
                <Row>
                    <Col xs="12" md="6">
                        <Image src={NOSOTROS} alt="..." fluid/>
                    </Col>
                    <Col xs="12" md="6">
                        <div className="title">Nosotros</div>
                        <div className="divisor" />
                        <div className="nosotros-description">
                            <span className="hide-mobile">
                                {
                                    !!nosotros ?
                                    parse(nosotros.content.rendered) :
                                    <p>Somos una empresa que se esfuerza en ofrecer productos y servicios de calidad
                                    creados para darle un giro de 180 grados al concepto clásico de una celebración.
                                    Tras más de cuatro años de experiencia y miles de unidades vendidas, en Pandamix
                                    hemos sabido complacer a nuestro público ofreciéndoles los mejores shows de <i>shots</i> para
                                    activar al máximo a cada uno de los invitados del evento,
                                    ofreciéndole no sólo un servicio sino una experiencia completa.
                                    </p>
                                }
                            </span>
                            <br className="hide-mobile"/>
                                {
                                    !!nosotros ?
                                    parse(nosotros.excerpt.rendered) :
                                    <p>Si lo que estás buscando es vivir un momento distinto y súper divertido,
                                    acompañado de los más deliciosos <i>Cocktail Shots</i>, estás en el lugar indicado.
                                    </p>
                                }
                            <br/>
                            ¡Contáctanos!
                        </div>
                    </Col>
                </Row>
            </section>
            <section id="productos">
                <div className="title">Productos</div>
                <div className="divisor" />
                <Carousel prevIcon={prevIcon} nextIcon={nextIcon} indicators={false}>
                    <Carousel.Item>
                        <Image src={PANDA_MIX} height={500}/>
                    </Carousel.Item>
                    <Carousel.Item>
                        <Image src={PANDA_TRONIC} height={500}/>
                    </Carousel.Item>
                    <Carousel.Item>
                        <Image src={PANDA_YELLOW} height={500}/>
                    </Carousel.Item>
                    <Carousel.Item>
                        <Image src={PANDA_PURPLE} height={500}/>
                    </Carousel.Item>
                </Carousel>
            </section>
            <section id="reel">
                <div style={{padding:"56.25% 0 0 0", position:"relative"}}>
                    <iframe title="reel" src="https://player.vimeo.com/video/356967557" style={{position: "absolute", top:0, left:0, width:"100%", height:"100%"}} frameBorder="0" allow="autoplay; fullscreen" allowFullScreen />
                </div>
                <script src="https://player.vimeo.com/api/player.js" />
            </section>
            <section id="stats">
                <VisibilitySensor onChange={countUpOnViewport}>
                    <Container>
                        <Row>
                            <Col xs="6" md="3" className="stat-element">
                                <Image height={100} src={EVENTOS}/>
                                <div className="stat-title">Eventos</div>
                                <div className="stat-value">
                                    {
                                        !!stats['eventos'] ? 
                                        <CountUp ref={(countUp) => {setEvents(countUp)}}
                                            end={stats['eventos']} duration={2} /> :
                                        0
                                    }

                                </div>
                            </Col>
                            <Col xs="6" md="3" className="stat-element">
                                <Image height={100} src={EXPERIENCIA} />
                                <div className="stat-title">Experiencia</div>
                                <div className="stat-value">
                                    {!!stats['experiencia'] ? stats['experiencia'] : 0} Años
                                </div>
                            </Col>
                            <Col xs="6" md="3" className="stat-element">
                                <Image height={100} src={PRODUCTOS} />
                                <div className="stat-title">Productos Vendidos</div>
                                <div className="stat-value">
                                    {
                                        !!stats['productos-vendidos'] ?
                                        <CountUp ref={(countUp) => {setProducts(countUp)}}
                                        end={stats['productos-vendidos']} duration={2} /> :
                                        0
                                    }
                                </div>
                            </Col>
                            <Col xs="6" md="3" className="stat-element">
                                <Image height={100} src={CLIENTES} />
                                <div className="stat-title">Clientes</div>
                                <div className="stat-value">
                                    {
                                        !!stats['clientes'] ?
                                        <CountUp ref={(countUp) => {setClients(countUp)}}
                                            end={(!!stats['clientes']) ? stats['clientes'] : 0} duration={2} /> :
                                        0
                                    }
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </VisibilitySensor>
            </section>
            <section id="faq">
                <div className="title">Preguntas Frecuentes</div>
                <div className="divisor" />
                <Container>
                    <Accordion className="faq-accordion">
                        {renderFAQ()}
                    </Accordion>
                </Container>
            </section>
            <PandaButton />
            <Footer sticky="bottom" page="home" />
        </div>
    )
}
